export const primaryBlue = '#14B9F1';

export const white = '#ffffff';
export const grayLight = '#ebeef0';
export const grayMedium = '#9ca8b4';
export const grayDark = '#6a8195';
export const black = '#000000';
export const pageBackgroundGray = '#fcfcfc';
export const materialRed = '#f44336';

export const disabledButtonGray = '#d9d9d9';
export const disabledButtonTextGray = '#999999';
export const textColorGray = '#666666';
export const gridHeaderColorGray = '#222222';
export const tableSelectedGray = '#f7f7f7';
export const tableHoverGray = '#f3f3f3';
export const hintTextGrayColor = '#ccc';

export const purpleDecorations = '#6f6dbc';

//TODO: Refactor sliding panel to support styling.
export const slidingPanelTitleGray = '#5c5c5c';



// WEBPACK FOOTER //
// ./src/theme/mainColors.js